import { useCallback, useContext } from "react";
import { customFieldConstants } from "../api/CustomFields/CustomFields";
import { customTypeConstants } from "../api/CustomTypes/CustomTypes";
import { datasetsConstants } from "../api/Datasets";
import { inventoryItemsConstants } from "../api/Inventories";
import { personsConstants } from "../api/Person";
import { projectsConstants } from "../api/Projects";
import { samplesConstants } from "../api/Samples";
import { SessionContext } from "../common/contexts/SessionContext";
import { getDetailLink } from "../main/Routing";
import { EntityMinimalModelWithType } from "../api/ApiTypes";
import { methodsConstants } from "../api/Method";
import { labNoteBooksConstants } from "../ELN/types/LabNotebook";
import { labNotebookExperimentsConstants } from "../ELN/types/LabNotebookExperiment";
import { labNotebookEntriesConstants } from "../ELN/types/LabNotebookEntry";
import { labNotebookTemplatesConstants } from "../ELN/types/LabNotebookTemplate";

export const useEntitiesRedirect = () => {
  const { route } = useContext(SessionContext);
  const redirectByUUID = useCallback(
    (result: EntityMinimalModelWithType) => {
      switch (result.type) {
        case "Sample":
          return route(getDetailLink(samplesConstants.frontendIndexRoute, result.id));
        case "Dataset":
          return route(getDetailLink(datasetsConstants.frontendIndexRoute, result.id));
        case "Person":
          return route(getDetailLink(personsConstants.frontendIndexRoute, result.id));
        case "InventoryItem":
          return route(getDetailLink(inventoryItemsConstants.frontendIndexRoute, result.id));
        case "Method":
          return route(getDetailLink(methodsConstants.frontendIndexRoute, result.id));
        case "Project":
          return route(getDetailLink(projectsConstants.frontendIndexRoute, result.id));
        case "CustomField":
          return route(getDetailLink(customFieldConstants.frontendIndexRoute, result.id));
        case "CustomType":
          return route(getDetailLink(customTypeConstants.frontendIndexRoute, result.id));
        case "Notebook":
          return route(getDetailLink(labNoteBooksConstants.frontendIndexRoute, result.id));
        case "NotebookExperiment":
          return route(getDetailLink(labNotebookExperimentsConstants.frontendIndexRoute, result.id));
        case "NotebookEntry":
          return route(getDetailLink(labNotebookEntriesConstants.frontendIndexRoute, result.id));
        case "NotebookTemplate":
          return route(getDetailLink(labNotebookTemplatesConstants.frontendIndexRoute, result.id));
        default:
          return "";
      }
    },
    [route]
  );

  return redirectByUUID;
};
